module.exports = "/images/inheritance.png?22499c19f2029454b15cb0a024c40c47";